module.exports = __webpack_public_path__ + "static/media/why_goodypack_en.58b9a0d6.png";